import * as Preact from 'preact';
import List from '@mui/material/List';
import makeStyles from '@mui/styles/makeStyles';

export type Props = {
    children: Preact.ComponentChildren;
};

/**
 * A wrapper component for grouping the two types of config cards, Question and Product cards
 */

export const Component = (p: Props) => {
    const styles = makeStyles({
        endPadding: {
            '&:last-child:after': {
                content: '""',
                display: 'block',
                width: '0px',
                height: '0px',
            },
        },
    });

    return (
        <List
            id="list-container"
            sx={{
                display: 'flex',
                height: { xs: '100%', md: 'max-content' },
                gap: '16px',
                flexDirection: 'row',
                flexWrap: { xs: 'nowrap', md: 'wrap' },
                boxSizing: 'border-box',
                width: { xs: 'fit-content', md: '100%' },
                justifyContent: 'flex-start',
                alignItems: 'center',
                bgcolor: 'background.paper',
                padding: {
                    xs: '0px 0px 0px 16px',
                    md: `8px 0px 16px 24px`,
                },
            }}
            className={styles().endPadding}
        >
            {p.children}
        </List>
    );
};
